module.exports = __webpack_public_path__ + "img/banner_06.760d7d7.gif";